import React from 'react';
import classes from './FooterNav.module.css';
import Mail from '../../../assets/images/icons/mail.png';
import Pin from '../../../assets/images/icons/pin.png';
import Phone from '../../../assets/images/icons/phone.png';



const FooterNav = (props) => (
  <nav className={classes.FooterNavigation}>
    <ul>
      <li>
        <img src={Pin} alt="bnikushev@zebra.bg" />
        <span>Sofia, Str. Buntovnik 56</span>
      </li>
      <li>
        <img src={Phone} alt="bnikushev@zebra.bg" />
        <a>+359 88 6 224 366</a>
      </li>
      <li>
        <img src={Mail} alt="bnikushev@zebra.bg" />
        <a href="mailto:bnikushev@zebra.bg">bnikushev@zebra.bg</a>
      </li>
    </ul>
  </nav>
);

export default FooterNav;
